import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from 'components/Dialog';
import Card from 'components/Card';
import CardActions from 'components/Card/Actions';

const styles1 = {
  dialogBody: {
    textAlign: 'center',
  },
  cardLayout: {
    borderRadius: 15,
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    padding: '10px 70px',
  },
  button: {
    borderRadius: 15,
    backgroundColor: '#0076BB',
    color: '#FFFFFF',
  },
  cardActions: {
    display: 'inline-flex',
    paddingBottom: 24,
  },
  descriptionNew: {
    fontFamily: 'jost',
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: '15%',
    color: '#656565',
  },

};
const VerifyAlert = ({ setIsVerifyAlert, alertMsg, isVerifyAlert }) => {
  return (
    <Dialog
      onRequestClose={() => {
        setIsVerifyAlert(false);
      }}
      open={isVerifyAlert}
      bodyStyle={styles1.dialogBody}
    >
      <Card style={styles1.cardLayout} rounded>
        <div
          style={{
            ...styles1.descriptionNew,
            textAlign: 'center !important',
            marginTop: '12%',
          }}
        >
          {alertMsg}
        </div>
        <CardActions noTopPadding style={styles1.cardActions}>
          <Button
            style={{ ...styles1.button, marginTop: '5%' }}
            variant='contained'
            onClick={() => {
              setIsVerifyAlert(false);
            }}
          >
            Okay
          </Button>
        </CardActions>
      </Card>
    </Dialog>
  );
};

VerifyAlert.propTypes = {
  setIsVerifyAlert: PropTypes.object.isRequired,
  alertMsg: PropTypes.object.isRequired,
  isVerifyAlert: PropTypes.object.isRequired,

};
export default VerifyAlert;
